import serviceimg from '../generativeassets/genservice.png';
import './GenerativeServices.css';

export default function GenerativeServices() {
  return (
    <div id='generative-service' className='generativemainclass'>
  <h2 className="heading">Generative AI Services Designed to Scale
Across the Enterprise</h2>
      <p className="subheading">
    Unlock new possibilities with comprehensive Generative AI development services  </p>
      <div className="bottom">
        <div className="left">
<img src={serviceimg} alt="error" />
        </div>
        <div className="right">
<div className='content'>
<h2>Generative AI Consulting</h2>
<span>Make GenAI work smarter for your business. We help identify high-impact use cases and design responsible, scalable deployments—aligning AI capabilities with real business goals, without guesswork or over-engineering.</span>
</div>
<div className="content contentborder">
  <h2>LLM Configuration</h2>
  <span>We configure large language models to align with your workflows, security requirements, and governance standards. Whether leveraging OpenAI or open-source models, each setup is optimized for performance, contextual accuracy, and enterprise-grade control.</span>
</div>
<div className="content">
  <h2>LLM Testing & Fine-Tuning</h2>
  <span>Out-of-the-box models rarely meet enterprise demands. We validate real-world use cases, optimize parameters, and fine-tune models on proprietary data to deliver sharper, more accurate, and business-aligned responses.</span>
</div>
<div className="content">
  <h2>Prompt Engineering</h2>
  <span>We design and optimize prompt workflows that steer GenAI models toward consistent, accurate, and context-aware outputs—across customer-facing experiences and internal operations.</span>
</div>
<div className="content">
  <h2>AI Agent Development</h2>
  <span>We build task-driven AI agents that deliver real outcomes—resolving tickets, generating content, and supporting teams. Each agent is customized, auditable, and designed to integrate seamlessly with your systems and governance processes.</span>
</div>
            </div>
      </div>
    </div>
  )
}
